__turbopack_context__.v({
  "closeButton": "sections-module-sass-module__4zqAfW__closeButton",
  "menuItem": "sections-module-sass-module__4zqAfW__menuItem" + " " + __turbopack_context__.i(696990)["menuItem"],
  "messagesContainer": "sections-module-sass-module__4zqAfW__messagesContainer",
  "myBets": "sections-module-sass-module__4zqAfW__myBets",
  "notificationsCount": "sections-module-sass-module__4zqAfW__notificationsCount",
  "profileDetailsModal": "sections-module-sass-module__4zqAfW__profileDetailsModal",
  "subMenu": "sections-module-sass-module__4zqAfW__subMenu",
  "unreadMsgsCount": "sections-module-sass-module__4zqAfW__unreadMsgsCount",
});
